module.exports = __webpack_public_path__ + "static/media/refurbishCarpetBlinds.8ffec933.jpg";